import WeddingInvitation from "./WeddingInvitation";
import { datosEjemplo } from "./sampleData";
import { temasPreset } from "./temas";

// Definición de catálogo: identificador estable, tipo de evento, paletas y contenido.
export const definicion = {
  id: "boda-editorial",
  tipoEvento: "boda",
  tipoEtiqueta: "Boda",
  nombre: "Editorial Botánica",
  descripcion:
    "Composición editorial con fotografía protagonista a pantalla completa, tipografía serif de alto contraste y ritmo de revista. En escritorio la portada queda fija a la izquierda.",
  miniatura: datosEjemplo.fotos.portada,
  // Capturas reales por paleta (scripts/generar_miniaturas.py); si falta el
  // archivo, la tarjeta usa la foto de portada como respaldo.
  miniaturas: {
    botanica: "/miniaturas/boda-editorial-botanica.jpg",
    terracota: "/miniaturas/boda-editorial-terracota.jpg",
    azulNoche: "/miniaturas/boda-editorial-azulNoche.jpg",
  },
  paletas: [
    { clave: "botanica", nombre: "Botánica", tema: temasPreset.botanica },
    { clave: "terracota", nombre: "Terracota", tema: temasPreset.terracota },
    { clave: "azulNoche", nombre: "Azul noche", tema: temasPreset.azulNoche },
  ],
  datosEjemplo,
  Componente: WeddingInvitation,
};
